import { c as _c } from "react/compiler-runtime";
import { Link } from "../../ui/Link";
import { cn } from "@local/utils/src/cn";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import { barlowCondensed } from "../../../utils/fonts";
import type { Offer } from "@local/offer/src/types";
import type { Route } from "next";
import { DiscountPrice } from "./DiscountPrice";
export interface BestSellersBigBlockProps {
  product: Offer.BlockListing;
  mobileImage?: Offer.BlockMedia;
  market?: string;
}
export const BestSellersBigBlock = t0 => {
  const $ = _c(28);
  const {
    product,
    mobileImage,
    market
  } = t0;
  const productUrl = `/${market}/product/${product.slug}`;
  const headingId = `bestseller-big-${product.instanceId}-name`;
  const t1 = mobileImage ? "hidden md:block" : "";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("h-full w-full transition-transform duration-300 ease-in-out group-hover:scale-105 motion-reduce:transition-none", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = product.image?.url ?? "";
  let t4;
  if ($[2] !== t3) {
    t4 = getCdnUrl({
      src: t3
    });
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `url(${t4})`;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      backgroundImage: t5,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t2 || $[7] !== t6) {
    t7 = <div className={t2} style={t6} />;
    $[6] = t2;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== mobileImage) {
    t8 = mobileImage && <div className="h-full w-full transition-transform duration-300 ease-in-out group-hover:scale-105 motion-reduce:transition-none md:hidden" style={{
      backgroundImage: `url(${getCdnUrl({
        src: mobileImage.url ?? ""
      })})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }} />;
    $[9] = mobileImage;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== headingId || $[12] !== product.name) {
    t9 = <h3 id={headingId} className={`${barlowCondensed.className} text-4xl font-semibold uppercase lg:text-5xl`}>{product.name}</h3>;
    $[11] = headingId;
    $[12] = product.name;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== market || $[15] !== product.prices) {
    t10 = product.prices?.[0] && <DiscountPrice price={product.prices[0]} className="pt-2 text-2xl" market={market} onDark={true} />;
    $[14] = market;
    $[15] = product.prices;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <div className="pointer-events-none absolute bottom-0 left-0 w-full bg-gradient-to-b from-transparent to-gray-950"><div className="w-11/12 py-5 pl-5 md:w-10/12 lg:w-9/12">{t9}{t10}</div></div>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = productUrl as Route;
  let t13;
  if ($[20] !== headingId || $[21] !== t12) {
    t13 = <Link href={t12} prefetch={false} aria-labelledby={headingId} className="absolute inset-0 rounded-sm focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 focus-visible:outline-hidden" />;
    $[20] = headingId;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13 || $[25] !== t7 || $[26] !== t8) {
    t14 = <article className="group relative h-full w-full overflow-hidden text-white"><div className="relative h-full w-full">{t7}{t8}{t11}{t13}</div></article>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t7;
    $[26] = t8;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};